module.exports = __webpack_public_path__ + "img/sdk-0-0.23afe24.svg";